import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactSidebar = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello, I would like to schedule a consultation for civil litigation services.");
    window.open(`https://wa.me/254721320787?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.open('tel:+254721320787', '_self');
  };

  return (
    <div className="space-y-6">
      {/* Quick Contact */}
      <div className="bg-gradient-to-br from-primary to-accent rounded-2xl p-8 text-white">
        <div className="text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Icon name="Scale" size={24} color="white" strokeWidth={2} />
          </div>
          <h3 className="text-xl font-heading font-semibold mb-2">
            Need Litigation Support?
          </h3>
          <p className="text-white/90 text-sm mb-6">
            Get expert legal representation for your civil dispute with our experienced litigation team.
          </p>
          <div className="space-y-3">
            <Button
              variant="secondary"
              onClick={handleWhatsAppClick}
              iconName="MessageCircle"
              iconPosition="left"
              className="w-full"
            >
              WhatsApp Consultation
            </Button>
            <Button
              variant="outline"
              onClick={handleCallClick}
              iconName="Phone"
              iconPosition="left"
              className="w-full border-white/30 text-white hover:bg-white/10"
            >
              Call Now
            </Button>
          </div>
        </div>
      </div>

      {/* Contact Information */}
      <div className="bg-white rounded-2xl p-8 shadow-md border border-border-light">
        <h4 className="text-lg font-heading font-semibold text-text-primary mb-6">
          Contact Information
        </h4>
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Phone" size={16} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Phone</p>
              <p className="font-medium text-text-primary">+254 721 320 787</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Mail" size={16} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Email</p>
              <p className="font-medium text-text-primary">info@peterpartnerslaw.co.ke</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="MapPin" size={16} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Office</p>
              <p className="font-medium text-text-primary">Nairobi, Kenya</p>
            </div>
          </div>
        </div>
      </div>

      {/* Office Hours */}
      <div className="bg-gradient-to-br from-surface/20 to-primary/5 rounded-2xl p-8 border border-primary/10">
        <h4 className="text-lg font-heading font-semibold text-text-primary mb-6">
          Office Hours
        </h4>
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-text-secondary">Monday - Friday</span>
            <span className="font-medium text-text-primary">8:00 AM - 6:00 PM</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-text-secondary">Saturday</span>
            <span className="font-medium text-text-primary">9:00 AM - 1:00 PM</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-text-secondary">Sunday</span>
            <span className="font-medium text-text-primary">Emergency Only</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSidebar;